export default {
  iframe: "[iframe]"
};
